import { render, staticRenderFns } from "./orders-page.vue?vue&type=template&id=1cbe0dc5&scoped=true"
import script from "./orders-page.vue?vue&type=script&lang=js"
export * from "./orders-page.vue?vue&type=script&lang=js"
import style0 from "./orders-page.vue?vue&type=style&index=0&id=1cbe0dc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbe0dc5",
  null
  
)

export default component.exports